import { useEffect, useMemo } from 'react';
import { MultiStep, StepData, StepHeaderProps, useStepContext } from '@frontend/design-system';
import { stepStyles } from '../../../../components/step.styles';
import { CollectBaseStepProps } from '../../collect-multi-step.types';

export const CollectBaseStep = ({ children, header: headerProps, ...props }: CollectBaseStepProps) => {
  const header = useMemo<StepHeaderProps>(() => {
    return {
      showCancelAction: false,
      ...headerProps,
    };
  }, [headerProps]);

  return (
    <MultiStep.Step {...props} header={header} css={stepStyles.step}>
      <CollectBaseStepSyncStepData label={props.label}>{children}</CollectBaseStepSyncStepData>
    </MultiStep.Step>
  );
};

const CollectBaseStepSyncStepData = ({ children, label }: React.PropsWithChildren<{ label: StepData['label'] }>) => {
  const { setStepData, stepData } = useStepContext();

  useEffect(() => {
    if (label !== stepData.label) {
      setStepData({ ...stepData, label });
    }
  }, [label, stepData?.label]);
  return <>{children}</>;
};
